import { render } from "./SearchCardWide.vue?vue&type=template&id=d406e780&scoped=true"
import script from "./SearchCardWide.vue?vue&type=script&lang=js"
export * from "./SearchCardWide.vue?vue&type=script&lang=js"

import "./SearchCardWide.vue?vue&type=style&index=0&id=d406e780&scoped=scoped&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d406e780"]])

export default __exports__